import { Observable, of } from 'rxjs'
import { environment } from 'src/environments/environment'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { OrganizationSerializer } from './organization.serializer'

@Injectable()
export class OrganizationDocumentService {
  // TODO create some resource service to extend that works for services like this
  constructor(
    private http: HttpClient,
    private serializer: OrganizationSerializer
  ) {}

  public createOne(
    organizationId: number,
    documentId: number
  ): Observable<boolean> {
    return this.http.post<any>(
      `${environment.backendApiUrl}/organizations/${organizationId}/organization-document`,
      { organizationId, documentId }
    )
  }

  public deleteOne(
    organizationId: number,
    documentId: number
  ): Observable<boolean> {
    return this.http.delete<any>(
      `${environment.backendApiUrl}/organizations/${organizationId}/organization-document/${documentId}`
    )
  }
}
